import type { PhoneSendRequest, PhoneSendResult, PhoneVerifiedResponse, PhoneVerifyRequest } from '@/types/types';

import { request } from './client';

export function fetchCustomerAccount(customerId: number, params?: Record<string, string | number>) {
  return request('GET', `/v1/account/accounts/${customerId}`, params);
}
export function fetchCustomerAccounts(params?: Record<string, string | number>) {
  return request('GET', '/v1/account/accounts', params);
}

export function fetchStats(params?: Record<string, string | number>) {
  return request('GET', '/v1/account/stats', params);
}

export function fetchMetrics(params?: Record<string, string | number>) {
  return request('GET', '/v1/account/stats/available_metrics', params);
}

export function saveMetrics(params: Record<string, unknown>) {
  return request('POST', '/v1/account/stats/metrics', params);
}

// the phone section shows failures inline
const SKIP_DEFAULT_ERROR_HANDLER = { skipDefaultErrorHandler: true };

/** the backend code for a code that was requested for this number too recently */
const PHONE_THROTTLED_CODE = 235;
/** the backend code for a number that is already verified on the account */
const PHONE_ALREADY_VERIFIED_CODE = 236;

/** reports the numeric phone codes under the codes the verification UI already knows */
function normalizePhoneError(error: unknown): never {
  const body = (error as { responseJson?: { code?: unknown } } | null)?.responseJson;
  if (body?.code === PHONE_THROTTLED_CODE) body.code = 'verification_throttled';
  if (body?.code === PHONE_ALREADY_VERIFIED_CODE) body.code = 'verification_already_verified';

  throw error;
}

export function requestPhoneCode(accountId: number, body: PhoneSendRequest): Promise<PhoneSendResult> {
  return request('POST', `/v1/account/accounts/${accountId}/phone_verify`, {}, body, SKIP_DEFAULT_ERROR_HANDLER)
    .then((response) => ({
      resendAfterSeconds: response.resend_after,
      maskedNumber: response.masked_phone,
    }))
    .catch(normalizePhoneError);
}

export function confirmPhoneCode(accountId: number, body: PhoneVerifyRequest): Promise<PhoneVerifiedResponse> {
  return request('PUT', `/v1/account/accounts/${accountId}/phone_verify`, {}, body, SKIP_DEFAULT_ERROR_HANDLER)
    .then((response) => ({
      phoneNumber: response.phone_number,
      phoneVerifiedAt: response.phone_verified_at,
    }))
    .catch(normalizePhoneError);
}
